import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';
import {Redirect} from 'react-router-dom';
import {ComposedChart, Area, ResponsiveContainer, Tooltip, XAxis} from 'recharts';
import * as userActions from "../../actions/user";
import * as graphMethods from "../../lib/graph";
import ReactImageFallback from "react-image-fallback";
import {IMGIX_PATH, BUCKET_PATH} from "../../constants";
import AuthService from "../../lib/AuthService";

var dateFormat = require('dateformat');

class ListItem extends Component {

    constructor(props) {
        super(props);

        var toDate = new Date();
        var fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 365);


        this.state = {
            visible: false,
            vignetId: '',
            vignet_name: '',
            selected_class : '',
            graphDuration: 'month',
            fromDate: fromDate.toLocaleDateString("en-US"),
            toDate: toDate.toLocaleDateString("en-US"),
            graphData : undefined,
            flipClass : '',
            btn_golive :'inactive'
        };
        this.Auth = new AuthService();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.selectVigs = this.selectVigs.bind(this);
        this.triggerPop = this.triggerPop.bind(this);
        this.getVigProps = this.getVigProps.bind(this);
        this.blockDetailView =  this.blockDetailView.bind(this);
        this.showVigPlayer =  this.showVigPlayer.bind(this);

    }

    handleInputChange(event) {

        this.setState({
            [event.target.name]: event.target.value
        });

    }
    componentDidMount() {


    }
    selectVigs(e, vignetId) {
        e.stopPropagation();
        this.setState(prevState => ({
            selected_class: (prevState.selected_class === '')? 'selected' : ''

        }));
        this.props.selectVignets(vignetId);
    }

    triggerPop(e, vignet) {
        e.stopPropagation();
        this.setState({redirect : true});
    }

    getVigProps(vigId){
        let data = { vignet_id : vigId, section : 'list', index : 0, section_name : 'list'};
        this.props.allVignetsProps(data);
    }

    blockDetailView(e, buildUrl) {
        e.preventDefault();
        e.stopPropagation();
        if(this.props.itemType === 'vignets' ) {
            //window.open(buildUrl);
            window.open(buildUrl);
        }
    }

    viewPlaylist(e, viewUrl) {
        e.preventDefault();
        e.stopPropagation();
        window.open(viewUrl);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.vignetsData.selected_ids !== prevProps.vignetsData.selected_ids && this.props.vignetsData.selected_ids.length === 0) {
            this.setState({selected_class : ''});
        }


        if (this.props.vignetsData.graphData !== prevProps.vignetsData.graphData) {

            let vignetGraph = this.props.vignetsData.graphData;
            this.setState({ vignetGraph : vignetGraph, graphData : vignetGraph });

            let startDate = this.state.fromDate;
            let endDate = this.state.toDate;

            if (this.state.graphDuration === 'month' ) {


                let summaryRes = [];

                for (let [key , value ] of graphMethods.formatJsonAsGraph(vignetGraph)) {
                    summaryRes[key] = value;
                }

                vignetGraph = summaryRes;

                let thisDate = new Date(startDate);
                let toDate = new Date(endDate);


                let currentMonth = thisDate.getMonth();
                let currentYear = thisDate.getFullYear();
                let toYear = toDate.getFullYear();

                let noOfMonths = graphMethods.getNoOfMonthsInBetween(startDate, endDate);

                for (let monthNo = 1; monthNo <= noOfMonths; monthNo++) {

                    if(currentYear <=toYear) {
                        let keyDate = new Date(Date.UTC(currentYear,currentMonth,'1','0','0','0'));
                        let this_key = keyDate.getTime();

                        let xLabel = graphMethods.getFormattedMonth(currentMonth, currentYear);
                        vignetGraph[this_key] = vignetGraph[this_key] ? graphMethods.addNewField(vignetGraph[this_key], xLabel, this.state.graphDuration)  : { 'vignet_views' : 0, 'page_views':0, 'month': this_key, 'name' : xLabel };

                        if(currentMonth === 12) {
                            currentMonth = 1;
                            currentYear++;
                        }
                        currentMonth++;
                    }
                }

                vignetGraph =  vignetGraph.sort(graphMethods.sortByKey("month"));
            }


            let graphData = Object.values(vignetGraph);
            this.setState({ graphData : graphData });

        }
    }


    showStatistics(e) {
        e.stopPropagation();
        this.setState({flipClass : 'flip'});

        let id = this.props.detail.uniqueId;

        let startDate = new Date(this.state.fromDate);
        let endDate = new Date(this.state.toDate);
        let fromDate = startDate.toLocaleDateString("en-US");
        let toDate = endDate.toLocaleDateString("en-US")
        let graph_params = { vignetId: id, type: this.state.graphDuration, fromDate: ( fromDate ? fromDate : this.state.fromDate), toDate: ( toDate ? toDate : this.state.toDate), section_name : 'list', index : this.props.id};

        this.props.fetchGraphData(graph_params);
    }

    showVigPlayer(e) {
        e.stopPropagation();
        let id = this.props.detail.uniqueId;
        let itemlive = this.props.detail.public_view;
        let playerUrl = '';

        if(id ) {
            if(itemlive === 1) {
                playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ id;
            }
            else{
                playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ id+'//';
            }
        }
        window.open(playerUrl);
    }

    backToMain(e) {
        e.stopPropagation();
        this.setState({flipClass : ''})
    }


    render() {

        let item = this.props.detail;
        let index = this.props.id;

        if (this.state.redirect) {
            if(this.props.itemType === 'vignets' ) {
                return <Redirect to={'/vignet/'+item.uniqueId}/>;
            }
            else if(this.props.itemType === 'playlist' ) {
                return <Redirect to={'/playlist/'+item.uniqueId}/>;
            }
        }


        item.selected_class = "";
        item.builderUrl = '#';
        item.playerUrl = '#';
        if(this.props.itemType === 'vignets' ) {
            item.builderUrl = this.props.pageSettingsData.config.BUILDER_PATH+item.uniqueId+'/'+item.user_id;
            item.playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+item.uniqueId+'/'+item.user_id;
            item.imgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/cf'+item.uniqueId+'.jpg';

            if(this.props.playlistData.newImage !== '' && this.props.vignetsData && this.props.vignetsData.vignetsList && this.props.vignetsData.vignetsList[index].uniqueId === item.uniqueId){
                item.imgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/cf'+item.uniqueId+'.jpg';
            }

        }
        else if(this.props.itemType === 'playlist' ) {
            item.builderUrl = '/playlist/'+item.uniqueId;
            item.imgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+item.uniqueId+'.jpg';
            if(this.props.playlistData.newImage !== '' && this.props.playlistData && this.props.playlistData.playListItems && this.props.playlistData.playListItems[index].uniqueId === item.uniqueId){
                item.imgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+item.uniqueId+'.jpg';
            }
        }

        let defImgSrc = '/assets/images/no-gallery.jpg';

        return (
            <div id={'item'+item.uniqueId} className={this.state.flipClass + " panel-block panel-col"} onClick={ (e) => {this.triggerPop(e,item)}}>
                <div className="face front">
                    <div className="image-upload-block">

                        <div className="image-up" >

                            {/*<img*/}
                            {/*    src={item.imgSrc}*/}
                            {/*    alt={item.imgSrc}*/}
                            {/*    className="my-image" />*/}
                            <ReactImageFallback
                                className="my-image"
                                src={item.imgSrc}
                                fallbackImage={defImgSrc}
                                initialImage={defImgSrc}
                                alt="cool image should be here"
                            />

                            <div className="upload-select">

                                {this.props.itemType === 'vignets' && item.user_id == this.Auth.getProfile().user_id &&
                                <button onClick={(e) => this.blockDetailView(e, item.builderUrl)}  className={"icon-lib edit-button"}></button>
                                }
                                {this.props.itemType === 'playlist' &&
                                <a href={item.builderUrl}>
                                    <button className={"icon-lib edit-button"}></button>
                                </a>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="title-wrapper edit-title">
                        <h5 className="title-box" >{item.name}</h5>
                        {/*<span className="highlight"></span>*/}
                        {/*<span className="bar"></span>*/}
                    </div>
                    <div className={"description-wrapper " + (this.props.itemType === 'user' ? " no-border" : "")}>
                        <div className="input-desc-block">
                            <span className="description-box">{item.display_name} </span>
                        </div>
                        <div className="input-desc-block">
                            <span className="description-box">{item.date_created ? dateFormat(item.date_created,"d mmm yyyy").toUpperCase() :'' }</span>
                        </div>
                    </div>
                    {this.props.itemType === 'vignets' &&
                    <div className="panel-button-block">
                        <div className="panel-button-block ico-btns">
                            <button className="panel-button icon-lib statistics" data-id={item.uniqueId} onClick={(e)=> this.showStatistics(e)}></button>
                            <button className="panel-button icon-lib viewbtn" data-id={item.uniqueId} onClick={(e)=> this.showVigPlayer(e)}  ></button>
                        </div>
                          </div>
                    }
                    {this.props.itemType === 'playlist' &&
                    <div className="panel-button-block">
                        <button className="panel-button" onClick={(e) =>this.viewPlaylist(e,item.listVignetUrl)}>VIEW PLAYLIST ({item.vignetCount})</button>
                    </div>
                    }

                    {this.props.itemType === 'vignets' &&
                    <React.Fragment>
                        {item.user_id == this.Auth.getProfile().user_id &&
                        <button data-id={item.uniqueId}
                                className={` icon-lib-list select-ico ${this.state.selected_class}`}
                                onClick={(e) => this.selectVigs(e, item.uniqueId)}></button>
                        }
                        {item.isLive === '1' &&
                        <button className="btn-golive"
                                onClick={ (e) => item.user_id == this.Auth.getProfile().user_id && this.props.confirmUnsetLive(e, item.uniqueId) }>Live</button>
                        }
                        {item.isLive !== '1' &&
                            <button  data-id={item.uniqueId}  className={`btn-golive ${this.state.btn_golive}`}
                                     onClick={(e) => item.user_id == this.Auth.getProfile().user_id  && this.props.confirmSetLive(e, item.uniqueId)} >Live</button>

                        }
                    </React.Fragment>
                    }
                </div>

                <div className="face back">
                    <div className="stat-header">
                        <h5 className="subheader">{item.name}</h5>
                    </div>
                    <div className="track-count-block">
                        <div className="ind-track-count">
                            <p className="track-text">Click</p>
                            <h5>{item.click_count?item.click_count:0}</h5>
                        </div>
                        <div className="ind-track-count">
                            <p className="track-text">Views</p>
                            <h5>{item.view_count?item.view_count:0}</h5>
                        </div>
                        {item.user_id == this.Auth.getProfile().user_id &&
                        <div className="ind-track-count btn-track">
                            <a onClick={(e) => this.blockDetailView(e, item.builderUrl)} href="javascript:;"
                               target="_blank" rel="noopener noreferrer">
                                <button className={"icon-lib edit-button"}></button>
                            </a>
                        </div>
                        }
                    </div>

                    <div className="track-table">
                        <div className="ind-track-table">
                            <span className="left-graph-text">Page View</span>
                            <span className="right-graph-text">{item.pageview_count?item.pageview_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">HOTSPOT</span>
                            <span className="right-graph-text">{item.hotspot_count?item.hotspot_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">IMAGE CLICK</span>
                            <span className="right-graph-text">{item.imageclick_count?item.imageclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">TEXT CLICK</span>
                            <span className="right-graph-text">{item.textclick_count?item.textclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">VIDEO</span>
                            <span className="right-graph-text">{item.video_count?item.video_count:0}</span>
                        </div>
                    </div>

                    <div className="chart-block">
                        <ResponsiveContainer width={212} height={46} aspect="width">
                            <ComposedChart  data={this.state.graphData} >
                                <Area type="monotone" dataKey="vignet_views" name={'nugget views'} fill="#45ace3" stroke="#45ace3" />
                                <Tooltip viewBox={{ x: 0, y: 0, width: 400, height: 400 }} active={true} wrapperStyle={{ width: 100, height:100 }}/>
                                <XAxis dataKey="name" tick={false} hide={true}/>
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="panel-button-block left-align">
                        <button className="panel-button back-button" onClick={(e)=> this.backToMain(e)}>Back</button>
                    </div>
                </div>
            </div>

        );
    }


}


ListItem.propTypes = {
    detail: PropTypes.object.isRequired,
    id:PropTypes.number.isRequired,
    selected_ids : PropTypes.array.isRequired,
    showDetailPopup : PropTypes.func
}


function mapStateToProps(state) {
    return {
        vignetsData  :state.vignets.vignetsData,
        userData  :state.user.userListData,
        playlistData  :state.playlist.playlistData,
        pageSettingsData  : state.pages.pageSettings
    };

}
export default  withRouter(connect(mapStateToProps,{
    selectVignets : vignetsActions.chooseVignets,
    allVignetsProps : vignetsActions.getVignetProps,
    fetchGraphData : vignetsActions.fetchGraphData,
    editUser : userActions.editUser
})(ListItem));



// WEBPACK FOOTER //
// ./src/components/common/listItem.js